"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tramonti-di-sotto": {
    "b5e7929c": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "beloz": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3cc09f5b": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "cleva": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb3f65c5": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "muinta": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72de2580": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "palcoda": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4fca3de9": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "san-vincenzo": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9fc027be": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "sclaf": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a728eb10": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "sialin": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4d445747": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "valent": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c009dfc3": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "zanon": [{
      "hkey": "1e90c95b",
      "slug": "tramonti-di-sotto",
      "name": "Tramonti di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;